import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFilterContext } from '../../contexts/FilterContext';
import CustomSelect from '../form/CustomSelect';
import { getPaymentTypeOptions } from '../../config/paymentTypeOptions';

const PaymentTypeFilter = ({ className, inputStyles }) => {
    const { t } = useTranslation();
    const { name, filterValue, setFilterValue, updateURLParams } = useFilterContext();

    const options = getPaymentTypeOptions(t);
    const selectedValues = filterValue ? filterValue.split(',') : [];
    const selectedOptions = options.filter((option) => selectedValues.includes(option.value));

    const handleChange = (selected) => {
        const value = (selected || []).map((option) => option.value).join(',');
        setFilterValue(value);
        updateURLParams(name, value);
    };

    return (
        <div className={`filter ${className || ''}`} style={inputStyles}>
            <CustomSelect
                isMulti
                isClearable
                options={options}
                value={selectedOptions}
                onChange={handleChange}
                placeholder={<div>{t('Select Payment Type')}</div>}
            />
        </div>
    );
};

export default PaymentTypeFilter;
